const formatPercent = (value: number) => `${(value * 100).toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;

const formatPercentagePoint = (value: number) => `${value.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} p.p.`;

const formatRange = (min: number | null | undefined, max: number | null | undefined, formatValue: (value: number) => string) => {
  const values = [
    min !== null && min !== undefined ? `Mín: ${formatValue(min)}` : null,
    max !== null && max !== undefined ? `Max: ${formatValue(max)}` : null,
  ].filter(Boolean);

  return values.length ? values.join(' | ') : 'Não configurado';
};

export const formatLimitRange = (min: number | null | undefined, max: number | null | undefined) => formatRange(min, max, formatPercent);

export const formatObjectiveLimitRange = (min: number | null | undefined, max: number | null | undefined) => formatRange(min, max, formatPercentagePoint);
